import React from "react";
import { Button, Card, Select, Table } from "antd";
import PropTypes from "prop-types";
import { sanitizeFieldName } from "../../util/methods";
import AccessControl from "../AccessControl";

const { Option } = Select;

const getColumns = (columns) => {
    const cols = Object.keys(columns).map(item => {
        if (columns[item].options && columns[item].options.notVisible) {
            return null;
        }
        if (item === '_id' || item === 'password') {
            return null;
        }
        return <Option key={columns[item].field}
            value={columns[item].field}>{sanitizeFieldName(columns[item].options.label || columns[item].field)}</Option>;
    });
    cols.push(<Option key='isCountable'
        value='isCountable'>{'Is Countable'}</Option>)
    cols.push(<Option key='vendor'
        value='vendor'>{'Purchase Vendor'}</Option>)
    cols.push(<Option key='latestCondition'
        value='latestCondition'>{'Latest Condition'}</Option>)
    cols.push(<Option key='qrLinked'
        value='qrLinked'>{'QR Linked'}</Option>)
    cols.push(<Option key='saleVendor'
        value='saleVendor'>{'Sale Vendor'}</Option>)
    cols.push(<Option key='latestAta'
        value='latestAta'>{'Latest ATA'}</Option>)
    return cols;
};

const List = ({
    title,
    columns,
    data,
    handleChange,
    columnChange,
    clearFilter,
    create,
    size,
    pagination,
    loading,
    filters,
    authUser,
    visibleColumn,
    seeReport,
    upload,
    makeLeasable,
    downloadToCSV,
    downloadQrCodes,
    downloadProgress
}) => {

    return (
        <Card className={`gx-card-metrics`}>
            <div className=''>
                <div className='action-bar'>
                    <AccessControl resource={title} permissionNeeded={'u'}
                        roles={authUser ? authUser.roles : []} render={(props) => {
                            return <Button type='primary' onClick={upload} icon='add'> Upload Document</Button>
                        }} />

                    <div className='action-bar'>

                        {/*<AccessControl resource={title} permissionNeeded={'r'}*/}
                        {/*               roles={authUser ? authUser.roles : []} render={(props) => {*/}
                        {/*  return <Button style={{marginRight: '10px', marginLeft: '10px'}} onClick={downloadQrCodes}>Download QR Codes</Button>*/}
                        {/*}}/>*/}
                        <AccessControl resource={title} permissionNeeded={'r'}
                            roles={authUser ? authUser.roles : []} render={(props) => {
                                return <Button style={{ marginRight: '10px' }}
                                    disabled={columns.length <= 1 || downloadProgress > 0}
                                    onClick={downloadToCSV}> {downloadProgress > 0 ? `Download Progress ${downloadProgress} MB` : 'Download to CSV'} </Button>
                            }} />

                        {
                            <AccessControl resource={title} permissionNeeded={'r'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return (visibleColumn && visibleColumn.length ?
                                        (<Select mode="multiple" maxTagCount={1} key={'1'}
                                            style={{ width: '200px', marginRight: '10px' }}
                                            placeholder="Visible Columns"
                                            defaultValue={visibleColumn}
                                            onChange={columnChange}>
                                            {getColumns(filters)}
                                        </Select>)
                                        : (<Select mode="multiple" maxTagCount={1} key={'2'}
                                            style={{ width: '200px', marginRight: '10px' }}
                                            placeholder="Visible Columns"
                                            defaultValue={visibleColumn}
                                            onChange={columnChange}>
                                            {getColumns(filters)}
                                        </Select>))
                                }} />
                        }


                        <Button onClick={clearFilter}>Clear filters and sorters</Button>
                    </div>
                </div>
                <Table columns={columns} dataSource={data} onChange={handleChange} scroll={{ x: 1200 }} size={size}
                    rowKey={'_id'}
                    pagination={pagination} loading={loading} />

                <div className='action-bar'>
                    <AccessControl resource={title} permissionNeeded={'u'}
                        roles={authUser ? authUser.roles : []} render={(props) => {
                            return <Button type='danger' onClick={makeLeasable} icon='edit'> Make Assets Leasable</Button>
                        }} />
                </div>
            </div>
        </Card>
    )
};

export default List;
List.defaultProps = {
    size: "middle"
};

List.propTypes = {
    title: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    columnChange: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    size: PropTypes.string,
    data: PropTypes.array.isRequired,
    create: PropTypes.func,
    pagination: PropTypes.object,
    loading: PropTypes.bool,
    filters: PropTypes.object,
    visibleColumn: PropTypes.array
};
